import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const getTaskDueCategory = (endDate) => {
    const taskDate = dayjs(endDate).startOf('day');
    // const today = dayjs().startOf('day');
    // const tomorrow = dayjs().add(1, 'day').startOf('day');

    // Get the start and end of the week (Sunday to Saturday)
    const weekStart = dayjs().startOf('week').startOf('day');
    const weekEnd = dayjs().endOf('week').startOf('day');

    if (taskDate.isToday()) {
        return 'dueToday';
    }
    if (taskDate.isTomorrow()) {
        return 'dueTomorrow';
    } if (taskDate.isSameOrAfter(weekStart) && taskDate.isSameOrBefore(weekEnd)) {
        return 'dueThisWeek';
    }
    return null; // Task is not due this week

};

export default getTaskDueCategory;
